import React, { FunctionComponent } from 'react';

import { KopecksIso } from '@utils/isomorph';
import { formatFloat } from '@utils/number';

type CurrencyProps = {
    amount: FeipApi.Kopecks;
    digits?: number;
    isTrailingZerosRemoved?: boolean;
    className?: string;
};

export const CurrencyPresenter: FunctionComponent<CurrencyProps> = (props) => {
    const { amount, digits = 2, className, isTrailingZerosRemoved = true } = props;

    return (
        <span className={className}>
            <span
                dangerouslySetInnerHTML={{
                    __html: formatFloat(
                        KopecksIso.to(amount),
                        digits,
                        '&nbsp;',
                        isTrailingZerosRemoved,
                    ),
                }}
            />
            &nbsp;₽
        </span>
    );
};
